/** @format */

import {useEffect, useState} from 'react';

import {SPINNER_PHRASES} from './spinnerPhrases';

const pickRandomPhrase = (prev: string | null): string => {
  if (SPINNER_PHRASES.length === 1) return SPINNER_PHRASES[0];

  let next = SPINNER_PHRASES[Math.floor(Math.random() * SPINNER_PHRASES.length)];
  while (next === prev) {
    next = SPINNER_PHRASES[Math.floor(Math.random() * SPINNER_PHRASES.length)];
  }
  return next;
};

export const useSpinnerPhrase = (active: boolean, intervalMs: number = 30_000): string | null => {
  const [phrase, setPhrase] = useState<string | null>(null);

  useEffect(() => {
    if (!active) {
      setPhrase(null);
      return;
    }

    setPhrase(pickRandomPhrase(null));

    const id = setInterval(() => {
      setPhrase(prev => pickRandomPhrase(prev));
    }, intervalMs);

    return () => clearInterval(id);
  }, [active, intervalMs]);

  return phrase;
};
